import { CoordsMessages, TranslationCoordsMessages } from "../interfaces";

export const messages: TranslationCoordsMessages = {
  [CoordsMessages.readCoordsSuccess]: "Coordenada(s) devuelta(s) con éxito",
  [CoordsMessages.noCoordFound]: "Ninguna coordenada registrada",
  [CoordsMessages.readCoordsError]: "Falla al buscar coordenada(s)"
};
